import * as React from "react";
import { useTranslation } from "react-i18next";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import { fetchAssetVulnerabilities } from "security-app/hooks/api/assetsAPI";
import columnRenderers from "./column-renderers";
import { TABLE_LAYOUT } from "./constants";
function VulnerabilitiesInfo({ assetId }) {
  const { t } = useTranslation("enterprise_security_assets");
  const fetchEntities = (searchParams) => fetchAssetVulnerabilities(assetId, searchParams);
  const keyFn = (searchParams) => ["assets", assetId, "vulnerabilities", searchParams];
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: t("vulnerabilities_info.human_name"),
      tableLayout: TABLE_LAYOUT,
      fetchEntities,
      keyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      searchPlaceholder: t("vulnerabilities_info.search_placeholder"),
      withoutURLParams: true,
      compactView: true
    }
  );
}
export default VulnerabilitiesInfo;
